import { Box, Link } from '@mui/material'
import ArticleWrap from '../components/layout/ArticleWrap'
import MetaSupport from '../components/meta/MetaSupport'

export default function HelpAndSupport () {
  return (
    <>
      <MetaSupport />
      <ArticleWrap title='Support'>
        <Box sx={{ pb: 7 }}>
          For help or any questions or requests about your pre-order, please email us at <Link href='mailto:support@altis.ai'>support@altis.ai</Link>
        </Box>
      </ArticleWrap>
    </>
  )
}
